// @flow
import { APP_SETTINGS_ATTRIBUTE, GET_APP_SETTINGS, SET_APP_SETTINGS } from './constants';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import type { Action } from '~/core/types';
import { getAppSettings } from './selectors';
import { getUserId } from '~/core/state/user/selectors';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { receiveAppSettings } from './actions';
import type { SetAppSettingsAction } from './types';
import { user as userApi } from '~/core/api';

export function* setAppSettingsSaga({ payload: settings }: Action<SetAppSettingsAction>): Generator<Effect, *, *> {
    const userId = yield select(getUserId);
    const currentSettings = yield select(getAppSettings);
    const outSettings = { ...currentSettings.toJS(), ...settings };

    yield call(handleApi(userApi.setAttribute), userId, APP_SETTINGS_ATTRIBUTE, outSettings);
    yield put(receiveAppSettings(outSettings));
}

function* watchSetAppSettings(): Generator<Effect, *, *> {
    yield takeEvery(SET_APP_SETTINGS, handleSaga(setAppSettingsSaga));
}

export function* getAppSettingsSaga(): Generator<Effect, *, *> {
    const userId = yield select(getUserId);
    const [response, error] = yield call(handleApi(userApi.getAttribute), userId, APP_SETTINGS_ATTRIBUTE);
    yield put(receiveAppSettings(error || response));
}

function* watchGetAppSettings(): Generator<Effect, *, *> {
    yield takeEvery(GET_APP_SETTINGS, handleSaga(getAppSettingsSaga));
}

export default [watchSetAppSettings, watchGetAppSettings];



// WEBPACK FOOTER //
// ./src/core/state/app-settings/sagas.js